"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * The chrome and the text roles every performance view shares.
 *
 * Deliberately not shared with other internal consoles. Each is a different
 * mechanism, and a stylesheet shared between them would be a thing neither owns
 * and both are afraid to change. What they do share is the product's own
 * design tokens, which is where the resemblance belongs.
 *
 * What lives here is what more than one view speaks: the page column, the
 * panels the charts sit in, and the roles text plays. A chart's own drawing
 * lives beside the chart, and the tables share their vocabulary through
 * perfTables.styles.js.
 *
 * The console is a tool, not a reading surface: it runs nearly edge to edge
 * because charts and wide tables want the screen. Numbers are set in monospace
 * so digits line up in a column, while prose keeps the product's own face.
 */
const styles = exports.styles = {
  page: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    flexGrow: "x1iyjqo2",
    width: "xh8yej3",
    boxSizing: "x9f619",
    maxWidth: "x1oqmd8z",
    marginLeft: "x8x9d4c",
    marginInlineStart: null,
    marginInlineEnd: null,
    marginRight: "xack27t",
    $$css: true
  },
  section: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  header: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    alignItems: "x1pha0wt",
    justifyContent: "x1qughib",
    $$css: true
  },
  heading: {
    fontSize: "xbw2k6l",
    fontFamily: "x1wl88yq",
    color: "x10kmngs",
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  intro: {
    color: "xcdm7ny",
    fontSize: "x1q2zfhj",
    maxWidth: "xe10afn",
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  backLink: {
    color: "xcdm7ny",
    fontSize: "x1q2zfhj",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    marginBottom: "xhbfen4",
    ":hover_color": "x1qfsr1m",
    $$css: true
  },
  controls: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    alignItems: "x6s0dn4",
    $$css: true
  },
  button: {
    fontFamily: "xm3uy08",
    fontSize: "x9bimuu",
    color: "xcdm7ny",
    backgroundColor: "xjbqb8w",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x1pq0x4f",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingTop: "x1iul6r4",
    paddingBottom: "xes99ow",
    paddingLeft: "x15u6esi",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1arb9wb",
    cursor: "x1ypdohk",
    ":hover_borderColor": "xun8cwn",
    ":hover_borderInlineColor": null,
    ":hover_borderInlineStartColor": null,
    ":hover_borderLeftColor": null,
    ":hover_borderInlineEndColor": null,
    ":hover_borderRightColor": null,
    ":hover_borderBlockColor": null,
    ":hover_borderTopColor": null,
    ":hover_borderBottomColor": null,
    ":hover_color": "x1qfsr1m",
    $$css: true
  },
  buttonActive: {
    borderColor: "xs5ia2r",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    color: "x19p3n1p",
    fontWeight: "x1s688f",
    $$css: true
  },
  subHeading: {
    fontSize: "x1l6gwhu",
    fontFamily: "x1wl88yq",
    color: "x10kmngs",
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  panels: {
    display: "xrvj5dj",
    gridTemplateColumns: "x1o61qjw x1o9kf09",
    columnGap: "xgvynzx",
    rowGap: "x1d474pu",
    marginTop: "xj1urod",
    marginBottom: "x14phcvn",
    $$css: true
  },
  panel: {
    minWidth: "xeuugli",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x1pq0x4f",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x1uz70x1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    backgroundColor: "xk6p4me",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  panelWide: {
    gridColumn: "x1osaytk x601d15",
    gridColumnStart: null,
    gridColumnEnd: null,
    $$css: true
  },
  panelHeader: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    alignItems: "x1pha0wt",
    justifyContent: "x1qughib",
    $$css: true
  },
  panelDescription: {
    color: "xcdm7ny",
    fontSize: "x1q2zfhj",
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: "x15s5u4p",
    marginBottom: null,
    $$css: true
  },
  wideCard: {
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x1agr7sc",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x1pq0x4f",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x1uz70x1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    backgroundColor: "xk6p4me",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  pager: {
    display: "x78zum5",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    alignItems: "x6s0dn4",
    justifyContent: "x13a6bvl",
    paddingTop: "x1b58sdr",
    $$css: true
  },
  mono: {
    fontFamily: "xm3uy08",
    $$css: true
  },
  prose: {
    fontFamily: "x1wl88yq",
    color: "x10kmngs",
    $$css: true
  },
  muted: {
    color: "xcdm7ny",
    fontSize: "x1q2zfhj",
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  errorText: {
    color: "xwiuzjs",
    fontSize: "x1q2zfhj",
    $$css: true
  },
  pill: {
    display: "x1rg5ohu",
    fontFamily: "xm3uy08",
    fontSize: "x9bimuu",
    borderRadius: "x1pq0x4f",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingTop: "x11mojvd",
    paddingBottom: "xgqvdwc",
    paddingLeft: "x14bkuyz",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1ijmo5n",
    $$css: true
  },
  pillRunning: {
    backgroundColor: "xkjg22i",
    color: "x188zkvq",
    $$css: true
  },
  unit: {
    fontFamily: "x1wl88yq",
    fontSize: "x9bimuu",
    color: "xcdm7ny",
    paddingLeft: "xqjs8ns",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    $$css: true
  },
  markerMeaning: {
    display: "x1lliihq",
    color: "xcdm7ny",
    fontFamily: "x1wl88yq",
    fontSize: "x9bimuu",
    paddingTop: "xrhwvvd",
    maxWidth: "x6amaq2",
    $$css: true
  }
};